import Vue from 'vue'
import Router from 'vue-router'
import appRouter from '@/router/router'
import pcRouter from '@/router/pcrouter'; //移动端路由

Vue.use(Router)

const RouterConfig = ({
  mode: 'history', 
  routes:pcRouter
})
if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
  RouterConfig.routes = appRouter
}
const router = new Router(RouterConfig);
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js